import styled from 'styled-components';

import DefaultGroupButton from '../parts/DefaultGroupButton';

export const FollowButton = styled.button`
    font-family: 'Alliance No.1';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 100%;
    letter-spacing: -0.02em;
    cursor: pointer;
    border: none;
    color: white;
    font-weight: bold;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 13px 18px;
    gap: 4px;
    height: 40px;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.6), rgba(255, 255, 255, 0.6)),
        linear-gradient(97.81deg, #aa039f 0%, #ed014d 49.48%, #f67916 100%);
    background-blend-mode: overlay, normal;
    border-radius: 20px;

    transition: all 0.2s ease-in-out;
    &:hover {
        box-shadow: 0 0 24px #aa039f;
    }

    @media (min-width: ${({ theme }) => theme.breakpoints.mobile}) {
        padding: 13px 40px;
        gap: 10px;
    }

    &:disabled {
        opacity: 0.8;
        cursor: not-allowed;
    }
`;

export const FollowingButton = styled(DefaultGroupButton)`
    width: 110px;

    & span:last-child {
        display: none;
    }

    &:hover,
    &:disabled {
        & span:first-child {
            display: none;
        }
        & span:last-child {
            display: block;
        }
    }
`;
